export default __webpack_public_path__ + "441b44ab2ad06a06bc7851e049159b25.png";